import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"

export const appConfig: AppConfig<"disturbed-v2"> = {
  appId: "disturbed-v2",
  cookiePrefix: "dis_v2",
  lang: "EN",
  admins: {
    mfaEnabled: false,
    otpExpiration: "10 minutes",
    sessionDuration: "30 days"
  },
  artist: {
    name: "Disturbed"
  },
  meta: {
    description: "Disturbed 2025 Tour"
  },
  emailSender: {
    name: "Disturbed",
    email: "disturbed@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/disturbed`
      }
    },
    get files() {
      return {
        exclusives: "disturbed-exclusives",
        fanClips: "disturbed-fan-clips",
        merchSkus: "disturbed-merch-skus",
        playlistCoverImages: "disturbed-playlist-cover-images",
        showImages: "disturbed-shows",
        showCheckInRequestImages: "disturbed-show-check-in-requests"
      }
    },
    get music() {
      return {
        trackAudios: "disturbed-playlist-tracks",
        playlistDownloadFiles: "disturbed-playlist-download-files"
      }
    }
  },
  merch: {
    initialOwnerId: "f4513e00-bb5f-4623-ac4b-9c5e06c45bf5",
    initialOwnerAddress: "0x415ceee583bd733d20b4c16316848e42aec73bc2"
  },
  tasks: {
    exclusiveLinkDelay: "1 hour"
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: "https://disturbed.store",
  socialLinks: [
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://disturbed.lnk.to/instagram"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://disturbed.lnk.to/facebook"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://disturbed.lnk.to/youtube"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://www.tiktok.com/@disturbed?lang=en"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://disturbed.lnk.to/twitter"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/artist/3TOqt5oJwL9BE2NG9MEwDa?si=O5qUjZQRROubB4k1yN0c1Q"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/disturbed_og_image.webp`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/check-in/disturbed-logo.webp`,
          width: 96
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email/disturbed-logo-gray.png`,
            width: 96
          }
        },
        background: `${appConfig.s3.assets.appUrl}/profile/profile-background.png`,
        howToTap: `${appConfig.s3.assets.appUrl}/tap_education_bg.png`,
        roulette: {
          images: Array.from(
            { length: 9 },
            (_, i) => `${appConfig.s3.assets.appUrl}/roulette/thumb-0${i + 1}.webp`
          )
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: `${appConfig.s3.assets.appUrl}/merch/disturbed-marquee-video.mp4`,
        howToTap: `${appConfig.s3.assets.appUrl}/how-to-tap-profile.mp4`
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: "https://disturbed.store/policies/privacy-policy",
        artistTermsOfService: "https://disturbed.store/policies/terms-of-service",
        sweepstakeRules:
          "https://iyk.notion.site/IYK-Disturbed-Sweepstakes-Official-Rules-EU-Tour-2025-2790f27a927f80c9a2dcc11db8c75169"
      }
    }
  }
}
